"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("bootstrap/dist/css/bootstrap.min.css");
require("bootstrap/dist/js/bootstrap.min.js");
require("./css/BrokerLeadGenerationTool.css");
var _reactBootstrap = require("react-bootstrap");
var _react = _interopRequireWildcard(require("react"));
var _reactDeviceDetect = require("react-device-detect");
var _youtube = _interopRequireDefault(require("react-player/youtube"));
var _axios = _interopRequireDefault(require("axios"));
var _useTranslation = _interopRequireDefault(require("./hooks/useTranslation.js"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*
This component aims to replace all instances of borrower lead contact forms
in use by SWMC. It renders a generic form with minimal styling so that the
form can easily be customized in each implementation.

The getNumbers function filters the user's input to possible phone numbers.
The three arrays that follow are used to verify that props passed into 
this component are expected inputs for the GENERATE_LEAD_API.

BrokerLeadGenerationTool handles the main logic for the form.
When the form is initially rendered, all the inputs are managed by useState hooks
All text is rendered from the useTranslation hook based on the keys in the corresponding locales json files.
Constants are established based on passed props and browser data.

handleSubmit pulls the form data from useState hooks and builds an object with passed props.
While building the object, the passed props are checked against expected inputs for the GENERATE_LEAD_API.
Any props that do not match are still passed, but a warning is sent to the console along with the expected inputs.
The warning allows the developer to change the prop to an expected input. 
The object is then used to either send an email or generate a lead based on whether or not a key exists.

When the form is initially loaded, the useEffect will auto populate the user's
information if there is a URL key. It will also generate the states list based
on the statesDomain and statesCode prop. If the props do not exist, SWMC.COM
is used by default. After the list is populated, the user's state is selected
based on their IP address.

The render statement will show the form, thank you content, or failure modal.
The forwardRef is added to the first name input so that the dev can scroll 
to the form and render a custom title while the form is visible.
The form feilds include Reference Number, First Name, Last Name, Email, Phone,
State, Message, and TCPA Consent.
The disabled reference number input is shown for use in swmc.com/callme and 
can be hidden by applying a display:none; style to the blg-col-0 element.

On successful submit, the form will be hidden and the thank you content will be shown.
This will cause the forwardRef to return a null node to the parent useCallback.
If the form fails to submit, then a modal is shown to have the user contact
lead.management@swmc.com directly.
*/

// Phone number filtering to just numbers that don't start with 0 or 1
function getNumbers(inVal) {
  var curChar = '';
  var okChars = '0123456789';
  var removeCharsFromPrefix = '01';
  var retVal = '';
  var tmpVal = inVal.trim();
  if (tmpVal !== '') {
    for (var i = 0; i < tmpVal.length; i++) {
      curChar = tmpVal.charAt(i);
      if (okChars.indexOf(curChar) !== -1) {
        if (retVal === '' && removeCharsFromPrefix.indexOf(curChar) !== -1) {
          //Do nothing
        } else {
          retVal += curChar;
        }
      }
    }
  }
  return retVal;
}

// Writable properties for GENERATE_LEAD_API as indicated by https://docs.google.com/spreadsheets/d/1MUCdGRs3-3XaDEB6lPV2-LWW_rnC4wuy-JKy4St1WuM/edit#gid=47818
// When updating this array, please also update the documentation above.
// Used to verify passed props are expected inputs for the GENERATE_LEAD_API
const apiKeys = ['active', 'armLoanCode', 'assignDate', 'baseLoanAmount', 'bestTimeContact', 'branch', 'clientBrowser', 'clientIP', 'clientOS', 'competitiveOffer', 'convertedToLoan', 'costcoMemberId', 'countyCode', 'createDate', 'currLoanUpb', 'currentAmount', 'currentMI', 'debtsPayoff', 'doNotCall', 'downPayment', 'escrowTransfer', 'estCityTax', 'estCountyTax', 'estFloodIns', 'estHzIns', 'estSchoolTax', 'estWindIns', 'expireDate', 'externalLeadId', 'fixRate', 'followUpDate', 'followUpReminder', 'imageGroupId', 'imagingId', 'leadPriority', 'leadSource', 'leadSourceKeyword', 'leadStatus', 'leadStatusKeyword', 'lender', 'loanActualType', 'loanClosed', 'loanOfficerUid', 'loanPurpose', 'loanPurposeKeyword', 'mainBtnName', 'mainBtnText', 'miType', 'noteRate', 'occupancy', 'offFeeDiscountPoint', 'offFeeEscrow', 'offFeeNotary', 'offFeeOrig', 'offFeeProcess', 'offFeeRecord', 'offFeeTitle', 'offFeeTransferTax', 'offFeeUnderWrite', 'offLendCredit', 'offerAmortType', 'offerAmount', 'offerCashoutAmount', 'offerLoanProductCode', 'offerLoanType', 'offerLoanTypeKeyword', 'offerMI', 'offerPI', 'offerRate', 'offerTerm', 'oldLoanNo', 'oldLoanType', 'oldPaymentDate', 'oldTerm', 'paymentType', 'payoffAmount', 'promoCode', 'propertyAddressCity', 'propertyAddressState', 'propertyAddressStreet1', 'propertyAddressStreet2', 'propertyAddressZipCode', 'propertyListingID', 'propertyType', 'propertyTypeKeyword', 'propertyValue', 'referrerId', 'requestReceivedDate', 'reverse', 'showModalBackBtn', 'showPropertyStateField', 'taxInstallmentType', 'testingLead', 'thankYouVideoUrl', 'thankYouVideoThumbnail', 'truAppHomePageUrl', 'uploadDate', 'webPageURL', 'companyName', 'brokerClient', 'termsAndConditionsURL', 'privacyPolicyURL', 'applyNowStateLicenseIn'];

// Expected borrower and coBorrower keys for lead generation api
// Used to verify passed props are expected inputs for the GENERATE_LEAD_API
const apiKeysBorrowers = ['TCPA_Consent_Given', 'addressCity', 'addressState', 'addressStreet', 'addressZipCode', 'cellPhone', 'dob', 'email', 'fax', 'fico', 'firstName', 'gender', 'lastName', 'maritalStatus', 'middleName', 'phone', 'ssn', 'suffix', 'workPhone'];

// Render the form with forwardRef to allow parent to know when the form is rendered.
const BrokerLeadGenerationTool = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const formRef = (0, _react.useRef)(null);
  const [clientIP, setClientIP] = (0, _react.useState)('');
  const [email, setEmail] = (0, _react.useState)('');
  const [firstName, setFirstName] = (0, _react.useState)('');
  const [formLoading, setFormLoading] = (0, _react.useState)(false);
  const [lastName, setLastName] = (0, _react.useState)('');
  const [consentValue, setConsentValue] = (0, _react.useState)(true);
  const [leadNoGenerated, setLeadNoGenerated] = (0, _react.useState)('');
  const [phone, setPhone] = (0, _react.useState)('');
  const [showContactForm, setShowContactForm] = (0, _react.useState)(true);
  const [showFailModal, setShowFailModal] = (0, _react.useState)(false);
  const [showConsenSection, setShowConsenSection] = (0, _react.useState)(false);
  const [showThankYouContent, setShowThankYouContent] = (0, _react.useState)(false);
  const [state, setState] = (0, _react.useState)('');
  const [statesOptions, setStatesOptions] = (0, _react.useState)('');
  const [userLocation, setUserLocation] = (0, _react.useState)('');
  const [validated, setValidated] = (0, _react.useState)(false);
  const [message, setMessage] = (0, _react.useState)('');
  const [showClickToMoreOpt, setShowClickToMoreOpt] = (0, _react.useState)(true);
  const {
    t
  } = (0, _useTranslation.default)();
  const [hashkey, setHashkey] = (0, _react.useState)(null);

  // Declare variables
  const queryParams = new URLSearchParams(window.location.search);
  const key = queryParams.get('key');
  const clientBrowser = _reactDeviceDetect.browserName + '-' + _reactDeviceDetect.browserVersion;
  const clientOS = _reactDeviceDetect.osName + '-' + _reactDeviceDetect.osVersion;

  // Set common values based on imported props
  const leadSource = props.leadSource ? props.leadSource : 'NET001';
  const loanOfficerUid = props.loanOfficerUid ? props.loanOfficerUid : 'CSTC';
  const truAppHomePageUrl = props.truAppHomePageUrl && typeof props.truAppHomePageUrl === 'string' ? props.truAppHomePageUrl : loanOfficerUid ? 'https://www.swmc.com/truapproval' + '?blof=' + loanOfficerUid : 'https://www.swmc.com/truapproval/';
  const branch = props.branch ? props.branch !== '' ? props.branch : '058' : '058';
  const promoCode = props.promoCode ? props.promoCode : '';
  const statesCode = props.statesCode ? props.statesCode : 'SUNWST000';
  const statesDomain = props.statesDomain ? props.statesDomain : 'swmc.com';
  const mainBtnName = props.mainBtnName ? props.mainBtnName : t('text2');
  const mainBtnText = props.mainBtnText ? props.mainBtnText : ''; /** Plain text field, since mainBtnName can have icons placed */
  const showModalBackBtn = props.showModalBackBtn ? props.showModalBackBtn : false;
  const showPropertyStateField = props.showPropertyStateField !== undefined ? props.showPropertyStateField : true;
  const webPageURL = props.webPageURL ? props.webPageURL : window.location.href;
  const companyName = props.companyName ? props.companyName : '';
  const brokerClient = props.brokerClient ? props.brokerClient : false;
  const termsAndConditionsURL = props.termsAndConditionsURL ? props.termsAndConditionsURL : '';
  const privacyPolicyURL = props.privacyPolicyURL ? props.privacyPolicyURL : '';
  const applyNowStateLicenseIn = props.applyNowStateLicenseIn ? props.applyNowStateLicenseIn : '';
  const thankYouVideoUrl = props.thankYouVideoUrl && typeof props.thankYouVideoUrl === 'string' ? props.thankYouVideoUrl : 'https://www.youtube.com/watch?v=7shKprV80dQ'; // this is latest video, came after D2cVp7lnzQo

  const thankYouVideoThumbnail = props.thankYouVideoThumbnail && typeof props.thankYouVideoThumbnail === 'string' ? props.thankYouVideoThumbnail : 'https://resources.swmc.com/swmc-images/Tru-Approval.jpg';
  let applyNowURL = process.env.REACT_APP_APPLY_NOW + '&leadNumber=' + leadNoGenerated + "&hash=" + hashkey;
  if (loanOfficerUid) {
    applyNowURL = applyNowURL + '&lof=' + loanOfficerUid;
  }
  let consentExtra1 = (0, _htmlReactParser.default)(t('consent_extra1'));
  if (mainBtnName) {
    let defaultMainButtonName = t('text2');
    if (mainBtnText) {
      consentExtra1 = consentExtra1.replace(defaultMainButtonName, mainBtnText);
    } else consentExtra1 = consentExtra1.replace(defaultMainButtonName, mainBtnName);
  }

  // Declare functional constants
  const handleFailClose = () => setShowFailModal(false);
  const goBackToFirstPage = () => setShowConsenSection(false);
  const closeModalWindow = () => {
    if (document.querySelector(".modal")) {
      document.getElementsByClassName("btn-close")[0].click();
    }
  };

  //Below is the function to remove non-printable ASCII chars
  //and special chars from the pass string
  function removeNonAsciiSpecialCharacters(str) {
    //check if pass value is null or blank.
    //return empty string if pass value is null or blank
    if (str === null || str === '') {
      return "";
    } else {
      //convert the pass value to string
      str = str.toString();
      //remove non-printable ASCII chars and replace it with empty string
      str = str.replace(/[^\x20-\x7E]/g, "");
      //replace all special characters with empty string
      str = str.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}0-9\[\]\\\/]/g, "");
      //return updated string to calling function
      return str;
    }
  }

  //first name validation
  const handleFirstName = evt => {
    let tempFirstName = evt.currentTarget.value;
    tempFirstName = removeNonAsciiSpecialCharacters(tempFirstName);
    if (tempFirstName) {
      if (tempFirstName.includes(' ') && lastName === '') {
        const name = tempFirstName.split(' ');
        let fName = name[0];
        let lName = name.slice(1).join(' ');
        setFirstName(fName.trim());
        setLastName(lName.trim());
      } else {
        setFirstName(tempFirstName.trim());
      }
    } else {
      setFirstName("");
    }
  };

  //last name validation
  const handleLastName = evt => {
    let tempLastName = evt.currentTarget.value;
    tempLastName = removeNonAsciiSpecialCharacters(tempLastName);
    if (tempLastName) {
      if (tempLastName.includes(' ') && firstName === '') {
        const name = tempLastName.split(' ');
        let fName = name[0];
        let lName = name.slice(1).join(' ');
        setFirstName(fName.trim());
        setLastName(lName.trim());
      } else {
        setLastName(tempLastName.trim());
      }
    } else {
      setLastName("");
    }
  };

  //remove trailing and leading space from email address
  const handleEmailAddress = evt => {
    let tempEmailAddress = evt.currentTarget.value;
    if (tempEmailAddress) {
      setEmail(tempEmailAddress.trim());
    } else {
      setEmail("");
    }
  };

  // Phone number validation
  const handleTelephoneNumber = evt => {
    // Save Phone number in local storage for Apply
    var tmpVal = getNumbers(evt.currentTarget.value).trim();
    var FirstThreeDigit = tmpVal.substring(0, 3);
    var FirstSixDigit = tmpVal.substring(0, 6);

    /* Below Pattern will check numbers between below ranges
        456, 555, 900,
        100, 101, ..., 199
        211, 311, ..., 911  ***811 removed
        370, 371, ..., 379
        960, 961, ..., 969
        800, 801, ..., 855  ***removed
        866, 877, 888, 800855
        */
    var patt = /^(1[0-9][0-9])|([2-7]11)|(911)|(37[0-9])|(96[0-9])|(456)|(555)|(866)|(877)|(888)|(900)$/;
    var patt2 = /^800855$/;
    if (patt.test(FirstThreeDigit)) {
      evt.currentTarget.value = '';
      return;
    } else if (patt2.test(FirstSixDigit)) {
      evt.currentTarget.value = '';
      return;
    }
    var curChar = '';
    var areaCode = '';
    var firstThree = '';
    var lastFour = '';
    var extension = '';
    if (tmpVal !== '') {
      for (var i = 0; i < tmpVal.length; i++) {
        curChar = tmpVal.charAt(i);
        if (i < 3) areaCode += curChar;
        if (i < 6 && i > 2) firstThree += curChar;
        if (i < 10 && i > 5) lastFour += curChar;
        if (i > 9) extension += curChar;
      }
    }
    var retVal = '';

    /* Do not put the parentesis if we only have the first three digits of the phone number.
    Once we are past that then start formatting the phone number. This was the main issue
    why the phone number couldn't be blanked out in it's entirety.*/
    if (areaCode !== '' && firstThree === '') retVal += areaCode;else if (areaCode !== '' && firstThree !== '') retVal += '(' + areaCode + ')';
    if (firstThree !== '') retVal += ' ' + firstThree;
    if (lastFour !== '') retVal += '-' + lastFour;
    if (extension !== '') retVal += ' x' + extension;else setPhone(retVal);
  };
  const showPhoneSoliticationConsent = () => {
    setShowClickToMoreOpt(false);
  };
  const hidePhoneSoliticationConsent = () => {
    setShowClickToMoreOpt(true);
  };

  // Build request data to be sent to generate leads api and email.
  const buildObj = () => {
    let name, fName, lName;
    let obj = {
      borrower: {},
      coBorrower: {}
    };
    // Add all props to obj so that they can be sent to borrower leads.
    if (props) {
      for (const [key, value] of Object.entries(props)) {
        // don't send required props that are not expected by the api.
        if (key !== 'statesCode' && key !== 'statesDomain' && key !== 'toEmailAddress' && key !== 'webPageURL' && key !== 'brokerClient' && key !== 'termsAndConditionsURL' && key !== 'privacyPolicyURL' && key !== 'applyNowStateLicenseIn' && key !== 'mainBtnName' && key !== 'showModalBackBtn' && key !== 'showPropertyStateField' && key !== 'thankYouVideoUrl' && key !== 'thankYouVideoThumbnail' && key !== 'truAppHomePageUrl' && key !== 'mainBtnText') {
          // build req data to be sent to generate leads api while filtering out invalid data.
          if (key !== 'borrower' && key.toLowerCase() !== 'coborrower' && value !== '') {
            obj[key] = value;
            if (!apiKeys.includes(key)) {
              // Warn the developer that the prop doesn't match any of the expected keys
              console.warn(`Unexpected prop: ${key}. Props must align with lead generation api expectations. If this is a correct key, please update the apiKeys array in broker-lead-generation-tool.`, apiKeys);
            }
          } else if (key === 'borrower') {
            if (typeof value !== 'object') {
              // Alert the developer that the borrower prop must be an object
              console.error(`Unexpected prop value for borrower: ${value}, expected an object`);
            } else {
              for (const [k, v] of Object.entries(value)) {
                if (v !== '') {
                  obj.borrower[k] = v;
                }
                if (!apiKeysBorrowers.includes(k)) {
                  // Warn the developer that the borrower object key doesn't match any of the expected keys
                  console.warn(`Unexpected borrower key: ${k}. Keys must align with lead generation api expectations. If this is a correct key, please update the apiKeysBorrowers array in broker-lead-generation-tool.`, apiKeysBorrowers);
                }
              }
            }
          } else if (key.toLowerCase() === 'coborrower') {
            if (typeof value !== 'object') {
              // Alert the developer that the coBorrower prop must be an object
              console.error(`Unexpected prop value for coBorrower: ${value}, expected an object`);
            } else {
              for (const [k, v] of Object.entries(value)) {
                if (v !== '') {
                  obj.coBorrower[k] = v;
                }
                if (!apiKeysBorrowers.includes(k)) {
                  console.warn(
                  // Warn the developer that the coBorrower object key doesn't match any of the expected keys
                  `Unexpected coBorrower key: ${k}. Keys must align with lead generation api expectations. If this is a correct key, please update the apiKeysBorrowers array in broker-lead-generation-tool.`, apiKeysBorrowers);
                }
              }
            }
          }
        }
      }
    }

    // delete original coBorrower values if they are still empty as we are not adding data in this function.
    if (JSON.stringify(obj.coBorrower) === '{}') {
      delete obj.coBorrower;
    }

    // ensure that first and last name are populated when both are entered into a single name field
    // swmc.com/callme is the main source for this logic as it will hide the last name field.
    if (firstName.includes(' ') && lastName === '') {
      name = firstName.split(' ');
      fName = name[0];
      lName = name.slice(1).join(' ');
    } else if (lastName.includes(' ') && firstName === '') {
      name = lastName.split(' ');
      fName = name[0];
      lName = name.slice(1).join(' ');
    } else {
      fName = firstName;
      lName = lastName;
    }
    obj.borrower.TCPA_Consent_Given = consentValue;
    if (email !== '') {
      obj.borrower.email = email;
    }
    if (fName !== '') {
      obj.borrower.firstName = fName;
    }
    if (lName !== '') {
      obj.borrower.lastName = lName;
    }
    if (phone !== '') {
      obj.borrower.phone = phone;
    }
    obj.branch = branch;
    obj.clientBrowser = clientBrowser;
    obj.clientIP = clientIP;
    obj.clientOS = clientOS;
    obj.leadSource = leadSource;
    obj.loanOfficerUid = loanOfficerUid;
    obj.location = userLocation;
    if (message !== '') {
      obj.message = message;
    }
    if (state !== '' && showPropertyStateField) {
      obj.propertyAddressState = state;
    }
    if (promoCode !== '') {
      obj.promoCode = promoCode;
    }
    return obj;
  };

  // Post requests to the lead generator will automatically send an email to lead.management@swmc.com.
  // Users that already have a lead number will not post to the lead generator.
  // This function should send an email whenever the lead generator does not and when additional emails need to be sent.
  // More data is expected to be sent here as this data would otherwise be lost.
  const sendEmail = (data, lead) => {
    // add the required keys to the data object to send the email.
    let emails;
    if (props.toEmailAddress) {
      if (process.env.REACT_APP_LEAD_MANAGEMENT_EMAIL === "developers@swmc.com" || process.env.REACT_APP_LEAD_MANAGEMENT_EMAIL === "qc@swmc.com") {
        emails = process.env.REACT_APP_LEAD_MANAGEMENT_EMAIL;
      } else {
        emails = props.toEmailAddress + ',' + process.env.REACT_APP_LEAD_MANAGEMENT_EMAIL;
      }
    } else {
      emails = process.env.REACT_APP_LEAD_MANAGEMENT_EMAIL;
    }
    data.leadNumber = lead;
    data.toEmailAddress = emails;
    data.webPageURL = webPageURL;

    // Pass the key so that the contact api knows this came from email campaign.
    if (key) {
      data.key = key;
    }
    _axios.default.post(process.env.REACT_APP_CONTACT_API, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).catch(error => {
      console.error('broker-lead-generation-tool Post #1', error);
    });
  };
  const handleSubmit = event => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      const brokerLeadGenerationForm = formRef.current;
      // pull all available data from form submit and props passed from parent.
      let obj = buildObj();
      if (obj) {
        if (!showConsenSection) {
          if (key && leadNoGenerated || leadNoGenerated) {
            // If a key exists, do not generate a new lead
            setFormLoading(true);
            // Send email regarding successful email campaign with all available data.
            sendEmail(obj, leadNoGenerated);
            // Set the lead number so that it can be used to redirect the user
            setLeadNoGenerated(leadNoGenerated);
            // show the consent section.
            setShowConsenSection(true);
            setFormLoading(false);
          } else {
            setFormLoading(true);
            let start = Date.now();
            _axios.default.post(process.env.REACT_APP_GENERATE_LEAD_API, obj, {
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(async res => {
              let bodyResponse = res.data.body;
              // nested if statements avoid error of undefined leadNumber
              if (bodyResponse) {
                if (bodyResponse.leadNumber) {
                  const leadNo = bodyResponse.leadNumber;
                  console.log(`Posting to GENERATE_LEAD_API took ${Date.now() - start}ms (broker-lead-generation-tool)`);
                  // email data is sent to qc and lead.management automatically via lead-superUser
                  // If a more verbose email is required then we can send it by passing a toEmailAddress prop.
                  // or by expanding the REACT_APP_LEAD_MANAGEMENT_EMAIL variable with comas 'qc@swmc.com,lead.management@swmc.com',
                  // if (
                  //   (leadNo && props.toEmailAddress) ||
                  //   (leadNo &&
                  //     // lead-service-superUser does not send emails to developers@swmc.com but this prevents spam.
                  //     // Change env variable to your personal email for testing.
                  //     process.env.REACT_APP_LEAD_MANAGEMENT_EMAIL !== 'developers@swmc.com' &&
                  //     process.env.REACT_APP_LEAD_MANAGEMENT_EMAIL !== 'qc@swmc.com' &&
                  //     process.env.REACT_APP_LEAD_MANAGEMENT_EMAIL !== 'lead.management@swmc.com')
                  // ) {
                  //   sendEmail(obj, leadNo);
                  // }
                  // Set the lead number so that it can be used to redirect the user
                  setLeadNoGenerated(leadNo);
                  // Call generateHash and wait for the result
                  const newHash = await generateHash(leadNo);
                  // Update the state with the generated hash
                  setHashkey(newHash);
                  // show the consent section.
                  setShowConsenSection(true);
                  setFormLoading(false);
                }
              }
            }).catch(error => {
              // Unique errors allow devs to quickly track down the problem.
              console.error('broker-lead-generation-tool Post #2', error);
              // Set the phone number to empty string as it is not reset with the rest of the form.
              setPhone('');
              // show the fail modal and and hide the thank you content.
              setShowFailModal(true);
              setShowThankYouContent(false);
              // Reset the form data and end form loading so that the form can be submitted again.
              brokerLeadGenerationForm.classList.remove('was-validated');
              brokerLeadGenerationForm.reset();
              setFormLoading(false);
            });
          }
        } else {
          // We need to update the generated lead info again as there might be the case user may
          // select I do not consent in the consent section after lead is generated 
          setFormLoading(true);
          obj.leadNumber = leadNoGenerated;
          let start = Date.now();
          _axios.default.post(process.env.REACT_APP_GENERATE_LEAD_API, obj, {
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(async res => {
            let bodyResponse = res.data.body;
            // nested if statements avoid error of undefined leadNumber
            if (bodyResponse) {
              if (bodyResponse.leadNumber) {
                const leadNo = bodyResponse.leadNumber;
                console.log(`Posting to GENERATE_LEAD_API took ${Date.now() - start}ms (broker-lead-generation-tool)`);
                // email data is sent to qc and lead.management automatically via lead-superUser
                // If a more verbose email is required then we can send it by passing a toEmailAddress prop.
                // or by expanding the REACT_APP_LEAD_MANAGEMENT_EMAIL variable with comas 'qc@swmc.com,lead.management@swmc.com',
                if (leadNo && props.toEmailAddress || leadNo &&
                // lead-service-superUser does not send emails to developers@swmc.com but this prevents spam.
                // Change env variable to your personal email for testing.
                process.env.REACT_APP_LEAD_MANAGEMENT_EMAIL !== 'developers@swmc.com' && process.env.REACT_APP_LEAD_MANAGEMENT_EMAIL !== 'qc@swmc.com' && process.env.REACT_APP_LEAD_MANAGEMENT_EMAIL !== 'lead.management@swmc.com') {
                  sendEmail(obj, leadNo);
                }
                // Set the lead number so that it can be used to redirect the user
                setLeadNoGenerated(leadNoGenerated);
                // Call generateHash and wait for the result
                const newHash = await generateHash(leadNo);
                // Update the state with the generated hash
                setHashkey(newHash);
                // Hide the contact form and consent section, then show the thank you content form.
                setShowContactForm(false);
                setShowConsenSection(false);
                setShowThankYouContent(true);
              }
            }
          }).catch(error => {
            // Unique errors allow devs to quickly track down the problem.
            console.error('broker-lead-generation-tool Post #2', error);
            // Set the phone number to empty string as it is not reset with the rest of the form.
            setPhone('');
            // show the fail modal and and hide the thank you content.
            setShowFailModal(true);
            setShowThankYouContent(false);
            // Reset the form data and end form loading so that the form can be submitted again.
            brokerLeadGenerationForm.classList.remove('was-validated');
            brokerLeadGenerationForm.reset();
            setFormLoading(false);
          });
        }
        setValidated(false);
      }
    }
    // required for the form to show validation ui elements.
    setValidated(true);
  };

  //REACT-335: Generate hash and submit it with lead number to Apply Now
  const generateHash = async leadNo => {
    let paraObj = {
      expire: 720,
      parameters: {
        leadNumber: leadNo
      }
    };
    try {
      const res = await _axios.default.post(process.env.REACT_APP_SUNSOFT_API_GENERATE_SESSION_KEY, paraObj, {
        headers: {
          "Content-Type": "application/json"
        }
      });
      return res.data.key; // Return the hash key
    } catch (error) {
      console.error("Error in generating hash key from the lead number", error);
      return null; // Return null if there's an error
    }
  };
  (0, _react.useEffect)(() => {
    if (key) {
      // Key will only exist for users redirected from email campaigns.
      // We want to keep the original lead number and pull enough data so the user can submit the form without adding additional info.
      let start0 = Date.now();
      _axios.default.post(process.env.REACT_APP_SUNSOFT_API_GET_SESSION_KEY, {
        "key": key
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        //console.log("response: " + JSON.stringify(response.data.parameters));
        let userData = response.data.parameters;
        if (userData.borrowerName) {
          // If the borrower name contains a space, split the first and last name.
          let name = userData.borrowerName.split(' ');
          setFirstName(name[0]);
          setLastName(name.slice(1).join(' '));
        } else {
          // If there is no borrower name, set the first and last name accordingly.
          if (userData.borrowerFirstName) {
            setFirstName(userData.borrowerFirstName);
          }
          if (userData.borrowerLastName) {
            setLastName(userData.borrowerLastName);
          }
        }
        setPhone(userData.borrowerPhone);
        setEmail(userData.emailAddress);
        setLeadNoGenerated(userData.leadNumber);
        return response;
      }).catch(error => {
        console.error('broker-lead-generation-tool Get GET_SESSION_KEY Error: ', error);
      }).finally(() => {
        console.log(`Below request to GET_SESSION_KEY took ${Date.now() - start0}ms (broker-lead-generation-tool)`);
      });
    }
    if (showPropertyStateField) {
      let start1 = Date.now();
      // Get states from public endpoint
      _axios.default.post(process.env.REACT_APP_SUNSOFT_RESTSERVER_STATE_LIST,
      // Removed timeout for compliance so states list is always shown.
      {
        domain: statesDomain,
        companyCode: statesCode
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        // Per Dennis, states should not be filtered on the front end.
        // The correct statesDomain should be used to fetch the correct states list.
        let validStates = response.data;
        if (validStates) {
          let tempStates = [];
          if (applyNowStateLicenseIn) {
            validStates.map((item, index) => {
              if (applyNowStateLicenseIn.includes(item.code)) {
                tempStates.push(item);
              }
            });
          } else {
            tempStates = validStates;
          }
          // Set the dropdown state list option.
          setStatesOptions(tempStates.map((item, index) => /*#__PURE__*/_react.default.createElement("option", {
            key: index,
            value: item.code
          }, item.name)));
          let start3 = Date.now();
          _axios.default.post(process.env.REACT_APP_MAXMIND, {}, {
            headers: {
              'Content-Type': 'application/json'
            }
          }, {
            timeout: 5000
          }).then(response => {
            if (response.data !== 'IP Not Available' && response.data !== 'Invalid Country') {
              setClientIP(response.data.userIP);
              let userLocation = response.data.userLocation;
              if (userLocation) {
                setUserLocation(userLocation.latitude + ', ' + userLocation.longitude);
              }
              let zipcode = response.data.zipcode;
              if (zipcode) {
                let start4 = Date.now();
                _axios.default.get(process.env.REACT_APP_SUNSOFT_RESTSERVER_ZIPCODE + zipcode, {
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }, {
                  timeout: 5000
                }).then(response => {
                  if (response.data.state) {
                    setState(response.data.state);
                  }
                }).catch(error => {
                  console.error('broker-lead-generation-tool Get ZIPCODE Error: ', error);
                }).finally(() => {
                  console.log(`Below request to ZIPCODE took ${Date.now() - start4}ms (broker-lead-generation-tool)`);
                });
              }
            }
          }).catch(error => {
            console.error('broker-lead-generation-tool Post MAXMIND Error: ', error);
          }).finally(() => {
            console.log(`Below request to MAXMIND took ${Date.now() - start3}ms (broker-lead-generation-tool)`);
          });
        }
      }).catch(error => {
        console.error('broker-lead-generation-tool STATE_LIST Error: ', error);
      }).finally(() => {
        console.log(`Below request to STATE_LIST took ${Date.now() - start1}ms (broker-lead-generation-tool)`);
      });
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "borrowerLeadGeneration"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    className: "blg-container",
    fluid: true
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "blg-row-0 shadow"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12,
    className: showThankYouContent ? 'blg-col-ty' : ''
  }, showContactForm && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, {
    autoComplete: "off",
    method: "POST",
    noValidate: true,
    onSubmit: handleSubmit,
    ref: formRef,
    validated: validated
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "blg-row-1"
  }, leadNoGenerated && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12,
    className: "blg-col-0"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    controlId: "reference",
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    "aria-label": t('reference'),
    disabled: true,
    onChange: e => setLeadNoGenerated(e.target.value),
    placeholder: t('reference'),
    type: "text",
    value: leadNoGenerated
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xxl: 6,
    md: 12,
    className: showConsenSection ? "d-none" : "d-block blg-col-1"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    controlId: "firstName",
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    "aria-label": t('firstname'),
    onChange: e => setFirstName(e.target.value),
    onBlur: handleFirstName,
    placeholder: t('firstname'),
    required: lastName === '',
    type: "text",
    value: firstName,
    ref: ref
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control.Feedback, {
    type: "invalid"
  }, t('firstnamevalidation')))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xxl: 6,
    md: 12,
    className: showConsenSection ? "d-none" : "d-block blg-col-2"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    controlId: "lastName",
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    "aria-label": t('lastname'),
    onChange: e => setLastName(e.target.value),
    onBlur: handleLastName,
    placeholder: t('lastname'),
    required: firstName === '',
    type: "text",
    value: lastName
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control.Feedback, {
    type: "invalid"
  }, t('lastnamevalidation')))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xxl: 6,
    md: 12,
    className: showConsenSection ? "d-none" : "d-block blg-col-3"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    controlId: "email",
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    "aria-label": t('email'),
    onChange: handleEmailAddress,
    pattern: "^[a-zA-Z0-9._\\-]+@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z0-9\\-]{2,64}$",
    placeholder: t('email'),
    required: phone === '',
    type: "text",
    value: email
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control.Feedback, {
    type: "invalid"
  }, t('emailvalidation')))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xxl: 6,
    md: 12,
    className: showConsenSection ? "d-none" : "d-block blg-col-4"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    controlId: "phone",
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    "aria-label": t('phone'),
    maxLength: 21,
    minLength: 14,
    onChange: handleTelephoneNumber,
    pattern: "^\\(?(\\d{3})\\)?-?\\s?(\\d{3})-?\\s?(\\d{4})[ ]*(( |x){1}[ ]?([0-9]){1,7}){0,1}$",
    placeholder: t('phone'),
    required: email === '',
    type: "text",
    value: phone
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control.Feedback, {
    type: "invalid"
  }, t('phonevalidation')))), showPropertyStateField ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12,
    className: showConsenSection ? "d-none" : "d-block blg-col-5"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    controlId: "state",
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Select, {
    "aria-label": t('yourpropertystate'),
    onChange: e => setState(e.target.value),
    placeholder: t('yourpropertystate')
    //required={state === ''}
    ,
    value: state
  }, /*#__PURE__*/_react.default.createElement("option", {
    value: ""
  }, t('yourpropertystate')), statesOptions), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control.Feedback, {
    type: "invalid"
  }, "Invalid"))) : "", /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12,
    className: showConsenSection ? "d-none" : "d-block blg-col-6"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    controlId: "message",
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    "aria-label": t('message'),
    as: "textarea",
    onChange: e => setMessage(e.target.value),
    placeholder: t('message'),
    rows: 3,
    value: message
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12,
    className: showConsenSection ? "d-block blg-col-8" : "d-none"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex"
  }, showClickToMoreOpt ? /*#__PURE__*/_react.default.createElement("h6", {
    className: "consentSmall",
    onClick: showPhoneSoliticationConsent
  }, t('consent_small'), ' ', /*#__PURE__*/_react.default.createElement("span", {
    id: "showConsentText",
    className: "consentLink showConsentText",
    title: t('show_title_text')
  }, t('show_consent_text'))) : /*#__PURE__*/_react.default.createElement("h6", {
    className: "consentSmall",
    onClick: hidePhoneSoliticationConsent
  }, t('consent_small'), ' ', /*#__PURE__*/_react.default.createElement("span", {
    id: "hideConsentText",
    className: "consentLink hideConsentText",
    title: t('hide_title_text')
  }, t('hide_consent_text')))), !showClickToMoreOpt ? /*#__PURE__*/_react.default.createElement("p", {
    id: "phoneSolicitationTerms",
    className: "consent-font pb-0"
  }, t('consent_text'), ' ', companyName, ' ', t('consent_text2'), ' ', companyName, ' ', t('consent_text3'), ' ', companyName, ' ', t('consent_text4'), ' ', companyName, ' ', t('consent_text5')) : ''), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12,
    className: showConsenSection ? "d-block blg-col-9" : "d-none"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Check, {
    "aria-label": t('consentlabel1'),
    defaultChecked: true,
    className: "checkIConsent",
    id: "iConsent",
    label: t('consentlabel1'),
    name: "checkIConsent",
    onClick: () => setConsentValue(true),
    type: "radio"
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Check, {
    "aria-label": t('consentlabel2'),
    className: "checkIConsent",
    id: "iDoNotConsent",
    label: t('consentlabel2'),
    name: "checkIConsent",
    onClick: () => setConsentValue(false),
    type: "radio"
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12,
    className: showConsenSection ? "d-none" : "d-block blg-col-10"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "consent-font"
  }, consentExtra1, ' ', companyName, ' ', process.env.REACT_APP_LANG === "en" ? (0, _htmlReactParser.default)(t('consent_extra11')) : "", process.env.REACT_APP_LANG === "en" ? " " : "", brokerClient ? /*#__PURE__*/_react.default.createElement("a", {
    className: "form-link",
    href: "https://www.swmc.com/terms-and-conditions",
    target: "_blank",
    rel: "noreferrer noopener"
  }, t('consent_extra2')) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, termsAndConditionsURL ? /*#__PURE__*/_react.default.createElement("a", {
    className: "form-link",
    href: termsAndConditionsURL,
    target: "_blank",
    rel: "noreferrer noopener"
  }, t('consent_extra2')) : t('consent_extra2')), ' ', process.env.REACT_APP_LANG === "es" ? (0, _htmlReactParser.default)(t('consent_extra11')) : "", process.env.REACT_APP_LANG === "es" ? " " : "", t('consent_extra3'), ' ', brokerClient ? /*#__PURE__*/_react.default.createElement("a", {
    className: "form-link",
    href: "https://www.swmc.com/privacy-policy",
    target: "_blank",
    rel: "noreferrer noopener"
  }, t('consent_extra4')) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, privacyPolicyURL ? /*#__PURE__*/_react.default.createElement("a", {
    className: "form-link",
    href: privacyPolicyURL,
    target: "_blank",
    rel: "noreferrer noopener"
  }, t('consent_extra4')) : t('consent_extra4')), t('consent_extra5'), ' ', process.env.REACT_APP_LANG === "en" ? (0, _htmlReactParser.default)(t('consent_extra6')) : "", process.env.REACT_APP_LANG === "en" ? " " : "", /*#__PURE__*/_react.default.createElement("a", {
    className: "form-link",
    href: "https://www.celligence.com/terms",
    target: "_blank",
    rel: "noreferrer noopener"
  }, t('consent_extra2')), ' ', t('consent_extra3'), ' ', /*#__PURE__*/_react.default.createElement("a", {
    className: "form-link",
    href: "https://www.celligence.com/privacy",
    target: "_blank",
    rel: "noreferrer noopener"
  }, t('consent_extra4')), process.env.REACT_APP_LANG === "es" ? " " : "", process.env.REACT_APP_LANG === "es" ? (0, _htmlReactParser.default)(t('consent_extra6')) : "", (0, _htmlReactParser.default)(t('consent_extra7')))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12,
    className: showConsenSection ? "d-none" : "d-block blg-col-11"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "divflex"
  }, showModalBackBtn ? /*#__PURE__*/_react.default.createElement("div", {
    className: "backBtnDiv modalBackBtn"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "secondary",
    className: "btn-submit",
    type: "button",
    onClick: closeModalWindow
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t('text10')))) :
  /*#__PURE__*/
  /** This is used to adjust button correctly*/
  _react.default.createElement("div", {
    className: "backBtnDiv modalBackBtn"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "whiteText"
  }, "\xA0")), /*#__PURE__*/_react.default.createElement("div", {
    className: "mainBtnDiv continueBtnDiv btnAdjustDiv"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    className: "btn-submit",
    type: "submit"
  }, formLoading ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border",
    "aria-hidden": "true",
    as: "span",
    role: "status",
    size: "sm"
  }), ' ', "Please wait...") : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _htmlReactParser.default)(mainBtnName)))))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12,
    className: showConsenSection ? "d-block blg-col-12" : "d-none"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "divflex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "backBtnDiv"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    className: "btn-submit",
    type: "button",
    onClick: goBackToFirstPage
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t('text10')))), /*#__PURE__*/_react.default.createElement("div", {
    className: "continueBtnDiv btnAdjustDiv"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    className: "btn-submit",
    type: "submit",
    variant: "success"
  }, formLoading ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border",
    "aria-hidden": "true",
    as: "span",
    role: "status",
    size: "sm"
  }), ' ', "Please wait...") : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t('text9')))))))), showThankYouContent && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "blg-row-2"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "data:image/png;base64,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",
    className: "blg-img",
    alt: "SWMC Sun West Mortgage Company Form Submitted Successfully"
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12,
    className: "blg-col-12"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-blue pb-0"
  }, t('text3'), " ", leadNoGenerated)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12,
    className: "blg-col-13"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-blue"
  }, t('text4'))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12,
    className: "blg-col-14 text-center"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "lg",
    className: "btn-start",
    href: applyNowURL,
    target: "_blank",
    rel: "noreferrer noopener"
  }, t('text6'))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12,
    className: "blg-col-15 pt-2"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "player-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_youtube.default, {
    className: "react-player",
    url: thankYouVideoUrl,
    width: "100%",
    height: "100%",
    light: thankYouVideoThumbnail,
    playing: true,
    controls: true
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12,
    className: "blg-col-16 text-center pt-2"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "lg",
    variant: "outline-primary",
    className: "btn-blg",
    href: truAppHomePageUrl,
    target: "_blank",
    rel: "noreferrer noopener"
  }, t('text5'))))))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, {
    size: "lg",
    centered: true,
    show: showFailModal,
    onHide: handleFailClose,
    backdrop: "static"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Body, null, t('text7'), " \xA0", /*#__PURE__*/_react.default.createElement("a", {
    href: 'mailto:inquiry@swmc.com',
    className: "form-link"
  }, "inquiry@swmc.com"), "."), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Footer, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    onClick: handleFailClose
  }, t('text8')))));
});
var _default = exports.default = BrokerLeadGenerationTool;